import {View} from 'react-native-web';
import { Maps } from '../../../element/Image';
import { Address, Date, Title } from '../../../element/Text';
import { Button } from '../../../element/Button';
import { useEffect, useState } from "react";
import { db } from '../../../firebase/FirebaseConfig';
import {collection, getDocs, query, where} from 'firebase/firestore';
import { auth } from '../../../firebase/FirebaseConfig';
import OpenLinkButton from "../../../element/Download";
import {PayPalScriptProvider, PayPalButtons} from "@paypal/react-paypal-js";
import {setDoc, doc} from 'firebase/firestore'







export default function Information({item, onPress }){

    const [flip, setFlip]=useState(true)
    const [pg, setPg]=useState([])
    const [message, setMessage]= useState('')
    
    const user= auth.currentUser
    console.log(item.title)
    useEffect(()=>{
        
            kimera()
          
    },[])
      
    async function kimera(){
        
        
        let png=[]
        let information=query(collection(db,"personaggi"),where("Death","==",false), where("Complete","==",true), where("User","==",user.uid));
        let querySnapshot= await getDocs(information);
              querySnapshot.forEach((docs)=>{png.push(docs.data());});
              if(png[0]==undefined){setFlip(true)
                setMessage("NON PUOI PRENOTARTI SE NON CONFERMI IL TUO PG")}
                
              else{
                let total= []
                let information1=query(collection(db,item.title));
                let querySnapshot1= await getDocs(information1);
                      querySnapshot1.forEach((docs)=>{total.push(docs.data().name);});
                console.log(total.length, total)
                if(total.length<40){
                if(total.includes(png[0].Name)){ setFlip(true)
                                              setMessage("Sei gia Iscritto") }
                else{
                setFlip(false)
                setPg([...png])
                setTimeout(5000)}}
              else{
                setFlip(true)
                setMessage("Mi dispiace ma abbiamo raggunto il numero massimo di giocatori per questo evento") 
              }}}

    async function SignIn(){
      await  setDoc(doc(db, item.title, pg[0].Name),{
        name:pg[0].Name,
        email:user.email,
        username:pg[0].UserName,
        });}
    
    return(
    <View style={{width:'100%', height:'100%', }}>  
             <Title value={item.title} color1={'#F9BA49'}/>
             <Maps source={item.image}/>
             <OpenLinkButton url={'https://www.google.com/maps/dir/40.9390208,14.2744813/agricampeggio+la+rotondola/@41.0601251,14.1073504,11z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x133af82010cfddd1:0x4741bd032ca3e2a8!2m2!1d14.2585728!2d41.1840218?entry=ttu'} text={'Navigazione'}/>
             <Date value={item.date} color1={'#F9BA49'}/>
             <Address value={item.address} color1={'#F9BA49'}/>
             <View style={{alignItems:'center', alignSelf:'center', width:'90%', height:45, marginTop:35 }}>
            {flip? <Title value={message} color1={'#F9BA49'}/>:<PayPalScriptProvider
        options={{ "client-id": "Acd-zaxllz7aZXtZOqBtHf0oU8gaS0-dBur7mS30vca8TO1nJOKiY3rY32g9i1JMiiQRrihlB0tM4BFp",
        currency: "EUR" }}
      >
        <PayPalButtons
          createOrder={(data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: "25.00",
                  },
                },
              ],
            });
          }}
          onApprove={async (data, actions) => {
            const details = await actions.order.capture();
            const name = details.payer.name.given_name;
            alert("ISCRITTO");
            SignIn()
          }}
        />
      </PayPalScriptProvider>}
             </View>
             </View>
    
    )}

    